<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CreatePage
  Reason: Dialog "Neuen Provisionslauf anlegen" on the run list - the metadata-driven cp.ProvisionRun
          create form (ProvisionRunForm derives period, valuta and name) with a caller-owned save.
-->
<p-dialog
        header="Neuen Provisionslauf anlegen"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '48rem'}"
        [breakpoints]="{'960px': '90vw'}"
        styleClass="cp-run-create-dialog">

    <p-message severity="info" styleClass="w-full mb-3">
        <span>
            Wählen Sie die Provisionsart. Periode, Valuta und Name werden danach aus dem letzten
            Lauf dieser Provisionsart fortgeschrieben: Die Periode beginnt am Tag nach dessen
            Periodenende und umfasst einen Monat, die Valuta ist der erste Tag der Periode.
            Abgebrochene Läufe zählen dabei nicht. Beim ersten Lauf einer Provisionsart geben Sie
            Periode und Valuta selbst ein.
        </span>
    </p-message>

    @if (formActive) {
        <!-- AI: CRUD Object Component for cp.ProvisionRun creation -->
        <mvs-crud-object #runForm
                [objectType]="objectType"
                [hideDefaultActions]="true"
                (onFormSubmitStateChange)="handleFormSubmitStateChange($event)"
                (onFormChange)="handleFormChange($event)"
                (onChangedObject)="handleChanged($event)"
                (onObjectChangeError)="handleError($event)">
        </mvs-crud-object>
    }

    @if (hasPeriod()) {
        <div class="flex flex-wrap align-items-center gap-2 mt-3 p-3 border-round-lg bg-blue-50 text-blue-900">
            <i class="fa-regular fa-calendar"></i>
            <span>Es wird angelegt:</span>
            @if (formValues?.name) {
                <span class="font-semibold">{{ formValues.name }}</span>
                <span>·</span>
            }
            <span class="font-semibold">
                {{ formValues.periodStartDate | date:'dd.MM.yyyy' }} – {{ formValues.periodEndDate | date:'dd.MM.yyyy' }}
            </span>
            @if (formValues?.valutaDate) {
                <span>· Valuta <span class="font-semibold">{{ formValues.valutaDate | date:'dd.MM.yyyy' }}</span></span>
            }
        </div>
    }

    @if (failureMessage) {
        <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
    }

    <ng-template #footer>
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleCancel()">
        </p-button>

        <p-button
                label="Provisionslauf anlegen"
                icon="fa-solid fa-plus"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable || busy"
                (onClick)="handleCreate()">
        </p-button>
    </ng-template>

</p-dialog>
